import { FileText } from 'lucide-react';

/**
 * Read-only preview grid of uploaded claim pictures/files.
 * Pulled out of EditClaimPanel for clarity. Pure component — no state.
 */
export default function ClaimPicturesList({ claim }) {
  let items = [];
  try {
    const raw = claim && claim.pictures ? claim.pictures : null;
    if (typeof raw === 'string' && raw.charAt(0) === '[') {
      items = JSON.parse(raw);
    } else if (Array.isArray(raw)) {
      items = raw;
    }
  } catch (_e) {
    items = [];
  }

  if (items.length === 0) {
    return (
      <div className="border border-gray-300 rounded bg-gray-50 p-3 mt-1 text-center text-sm text-gray-400" data-testid="pictures-empty-state">
        No pictures uploaded
      </div>
    );
  }

  function handleImgError(e) {
    const img = e.target;
    const item = items.find(function (p) { return img.src.includes(p.url?.split('/').pop()); });
    if (item && item.original_url && !img.dataset.triedOriginal) {
      img.dataset.triedOriginal = 'true';
      img.src = item.original_url;
      return;
    }
    const parent = img.parentNode;
    const name = img.alt || 'file';
    const ext = name.split('.').pop().toUpperCase();
    img.style.display = 'none';
    const placeholder = document.createElement('div');
    placeholder.className = 'w-28 h-20 flex flex-col items-center justify-center bg-gray-100 text-gray-400';
    placeholder.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg><span class="text-xs mt-1">' + ext + '</span>';
    parent.insertBefore(placeholder, img);
  }

  return (
    <div className="border border-gray-300 rounded bg-gray-50 mt-1 max-h-48 overflow-y-auto" data-testid="pictures-preview-grid">
      <div className="flex gap-2 p-2">
        {items.map(function (item, i) {
          const isImage = ['jpg','jpeg','png','gif','webp','bmp','svg'].indexOf((item.extension || '').toLowerCase()) !== -1;
          if (isImage) {
            return (
              <a key={item.url || i} href={item.url} target="_blank" rel="noopener noreferrer"
                className="flex-shrink-0 block border border-gray-300 rounded overflow-hidden hover:border-blue-400 w-28 bg-white">
                <img src={item.url} alt={item.name} className="w-28 h-20 object-cover" loading="lazy" onError={handleImgError} />
                <p className="text-xs text-gray-500 truncate px-1 py-0.5">{item.name}</p>
              </a>
            );
          }
          return (
            <a key={item.url || i} href={item.url} target="_blank" rel="noopener noreferrer"
              className="flex-shrink-0 flex flex-col items-center justify-center border border-gray-300 rounded p-2 hover:border-blue-400 w-28 h-24 bg-white">
              <FileText className="w-6 h-6 text-gray-400" />
              <p className="text-xs text-gray-500 truncate mt-1 w-full text-center px-1">{item.name}</p>
            </a>
          );
        })}
      </div>
    </div>
  );
}
